import * as Utils from '../utils/Utils';
import { ApiRequest } from './helper';

export async function list(a) {
  try {
    var parameters = [];

    if (!Utils.isUndefinedOrNull(a.typeId)) parameters.push('typeId=' + a.typeId);

    if (!Utils.isUndefinedOrNull(a.classId)) parameters.push('classId=' + a.classId);

    if (!Utils.isUndefinedOrNull(a.statusId)) parameters.push('statusId=' + a.statusId);

    const response = await ApiRequest(
      'GET',
      null,
      `${process.env.REACT_APP_API_URL}/api/SystemLogs/CTA${parameters.length > 0 ? '?' + parameters.join('&') : ''}`
    );

    if (response.ok) {
      const data = await response.json();
      a.success(data);
    } else {
      a.error(response.status);
    }
  } catch (error) {
    a.error();
  }
}

export async function save(a) {
  try {
    const response = await ApiRequest(
      'POST',
      JSON.stringify(a.data),
      `${process.env.REACT_APP_API_URL}/api/SystemLogs/CTA`
    );

    if (response.ok) {
      const data = await response.json();
      a.success(data);
    } else {
      a.error(response.status);
    }
  } catch (error) {
    a.error();
  }
}

export async function classes(a) {
  try {
    var parameters = [];

    if (!Utils.isUndefinedOrNull(a.applicationId)) parameters.push('applicationId=' + a.applicationId);

    const response = await ApiRequest(
      'GET',
      null,
      `${process.env.REACT_APP_API_URL}/api/SystemLogs/CTA/Classes${
        parameters.length > 0 ? '?' + parameters.join('&') : ''
      }`
    );

    if (response.ok) {
      const data = await response.json();
      a.success(data);
    } else {
      a.error(response.status);
    }
  } catch (error) {
    a.error();
  }
}

export async function saveclasses(a) {
  try {
    const response = await ApiRequest(
      'POST',
      JSON.stringify(a.data),
      `${process.env.REACT_APP_API_URL}/api/SystemLogs/CTA/Classes`
    );

    if (response.ok) {
      const data = await response.json();
      a.success(data);
    } else {
      a.error(response.status);
    }
  } catch (error) {
    a.error();
  }
}

export async function types(a) {
  try {
    const response = await ApiRequest('GET', null, `${process.env.REACT_APP_API_URL}/api/SystemLogs/CTA/Types`);

    if (response.ok) {
      const data = await response.json();
      a.success(data);
    } else {
      a.error(response.status);
    }
  } catch (error) {
    a.error();
  }
}

export async function savetypes(a) {
  try {
    const response = await ApiRequest(
      'POST',
      JSON.stringify(a.data),
      `${process.env.REACT_APP_API_URL}/api/SystemLogs/CTA/Types`
    );

    if (response.ok) {
      const data = await response.json();
      a.success(data);
    } else {
      a.error(response.status);
    }
  } catch (error) {
    a.error();
  }
}
